package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.cache.AuthCache
import com.rainbowclubs.rainbow.data.cache.BearerTokenCache
import com.rainbowclubs.rainbow.data.cache.ClubCache
import dev.gitlive.firebase.auth.AuthResult
import dev.gitlive.firebase.auth.FirebaseAuth

class LoginUseCase(
    private val auth: FirebaseAuth,
    private val authCache: AuthCache,
    private val clubCache: ClubCache,
    private val bearerTokenCache: BearerTokenCache,
) {
    suspend fun login(username: String, password: String): Result<AuthResult> {
        return try {
            val authResult = auth.signInWithEmailAndPassword(username, password)
            val userId = authResult.user?.uid
            if (!userId.isNullOrBlank()) {
                if (authCache.userUid != userId) {
                    bearerTokenCache.clear()
                    clubCache.clear()
                }
                authCache.userUid = userId
            }
            Result.success(authResult)
        } catch (e: Exception) {
            Result.failure(LoginException(e.message ?: "Unknown error"))
        }
    }
}

class LoginException(message: String) : Exception(message)
